/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { schema3OtherConnectApiV1SandboxGithubOauthConnectionsPost } from "../../funcs/schema3OtherConnectApiV1SandboxGithubOauthConnectionsPost.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .ConnectApiV1SandboxGithubOauthConnectionsPostRequest$inboundSchema,
};

export const tool$schema3OtherConnectApiV1SandboxGithubOauthConnectionsPost:
  ToolDefinition<typeof args> = {
    name: "schema-3-other-connect-api-v1-sandbox-github-oauth-connections-post",
    description: `Connect`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await schema3OtherConnectApiV1SandboxGithubOauthConnectionsPost(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
